import {  Button, Text } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { FaUserCircle } from 'react-icons/fa'
import { NavLink } from 'react-router-dom'
import { AuthContext } from '../Context/AuthContext'
function Profile() {
    const {isAuth,usname} = useContext(AuthContext)
    if(!isAuth){
      return <>
        <Button variant="outline" borderRadius="none" colorScheme="black"><NavLink to="/login">Log In</NavLink></Button>
        <Button variant="solid" ml="20px" borderRadius="none" colorScheme="teal"><NavLink to="/signup">Sign Up Free</NavLink></Button> 
      </>
    }else{
      return <>
        <NavLink to="/login"><FaUserCircle fontSize="30px"/></NavLink>
        <Text size="xl" ml="20px" fontSize="20px">Hi,{usname.current}</Text>
      </>
    }
}

export default Profile